import React from "react";
import { Button, Table, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function Commodities({ nextStep, prevStep }) {
  return (
    <>
      <div className="form-navigator-body">
        <Table bordered responsive>
          <thead className="table-secondary text-center">
            <tr>
              <th style={{ width: "30%" }}>Status of Commodity</th>
              <th style={{ width: "30%" }}></th>
              <th style={{ width: "10%" }}>Quantity available (In no.)</th>
              <th style={{ width: "10%" }}>No. of months (stock available)</th>
              <th style={{ width: "20%" }}>
                Remarks <br />
                <small>(Mention date of expiry, inadequate or stock out)</small>
              </th>
            </tr>
          </thead>
          <tbody>
            {/* First Row Group */}
            <tr>
              <td rowSpan={8} className="align-middle">
                Stock status of all HIV testing kits at district level
              </td>
              <td>HIV KIT-1 (No. of tests)</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter"/>
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>HIV KIT-2 (No. of tests)</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>HIV KIT-3 (No. of tests)</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>HIV KIT-4 WBFP (Whole Blood Finger Prick) (No. of tests)</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>
                Dual Rapid Diagnostic Test Kit (HIV and Syphilis) (No. of tests)
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>RPR Test kit (No. of tests)</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>DBS Cards (No. of tests)</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>DBS Collection Consumables</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            {/* Second Row Group */}
            <tr>
              <td rowSpan={15} className="align-middle">
                Stock status of all ARV Drugs
              </td>
              <td>Tenofovir300mg + Lamivudine300mg + Dolutegravir50mg (TLD)</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>Abacavir 600mg+Lamivudine 300mg (AL) adult</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            {/* 3 */}
            <tr>
              <td>Zidovudine300mg+Lamivudine 150mg (ZL Adult)</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            {/* 4 */}
            <tr>
              <td>Tenofovir300mg +Lamivudine300mg (TL)</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            {/* 5 */}
            <tr>
              <td>Dolutegravir 50mg (DTG Adult)</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            {/* 6 */}
            <tr>
              <td>Atazanavir300mg +Ritonavir100mg (ATV/r)</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            {/* 7 */}
            <tr>
              <td>Darunavir 600mg (DRV)</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            {/* 8 */}
            <tr>
              <td>Ritonavir 100mg (RTV)</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            {/* 9 */}
            <tr>
              <td>Dolutegravir 10mg (DTG Paed)</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            {/* 10 */}
            <tr>
              <td>Lopinavir 40mg +Ritonavir 10mg (LPV/r Paed Pellets)</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            {/* 11 */}
            <tr>
              <td>Abacavir 60mg+Lamivudine 30mg (AL paed)</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            {/* 12 */}
            <tr>
              <td>Zidovudine 60mg+Lamivudine 30mg (ZL-Pead)</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            {/* 13 */}
            <tr>
              <td>Lopinavir 100 +Ritonavir 25 (LPV/r Paed)</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            {/* 14 */}
            <tr>
              <td>Syrup Nevirapine (100 ml)</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            {/* 15 */}
            <tr>
              <td>Syrup Zidovudine (240 ml)</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            {/* Row 3 */}
            <tr>
              <td rowSpan={8} className="align-middle">
                Stock status of all STI Colour Coded Kits
              </td>
              <td>
                STI/RTI Kit- 1 contains Azithromycin 1gm and Cefixime 400 mg
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>
                STI/RTI Kit- 2 contains Secnidazole 1 gm- 2 tablets and
                Fluconazole 150 mg
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>STI/RTI Kit- 3 contains Azithromycin 1 gm</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>
                STI/RTI Kit- 4 contains Azithromycin 1 gm and Doxycycline 100 mg{" "}
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>STI/RTI Kit- 5 contains Acyclovir 400 mg</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>
                STI/RTI Kit- 6 contains Cefixime 400 mg, Doxycycline 100 mg and
                Metronidazole 400 mg
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>
                STI/RTI Kit- 7 contains Azithromycin 1 gm and Doxycycline 100 mg
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>
                STI/RTI Kit- 8-Benzathene Penicillin 24 Lac Units Dry Powder Inj
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            {/* Row 4 */}
            <tr>
              <td rowSpan={3} className="align-middle">
                Stock status of OST
              </td>
              <td>Tab Buprenorphine 0.4 mg</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>Tab Buprenorphine 2mg</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>Tab Buprenorphine + Naloxone 2/ 0.5 mg</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            {/* Row 5 */}
            <tr>
              <td>Stock status of condoms</td>
              <td className="text-center">-</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            {/* Row 6 */}
            <tr>
              <td>Stock status of Needle/Syringe</td>
              <td className="text-center">-</td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="number" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>
          </tbody>
        </Table>
      </div>

      <div className="form-navigate-footer">
        <button onClick={prevStep} className="btn btn-outline-secondary">
          Back
        </button>
        <button onClick={nextStep} className="btn btn-dark border-0">
          Next
        </button>
      </div>
    </>
  );
}
